<template>
  <div>
    <span v-if="item.teacher_name">{{ item.teacher_name }}</span>
    <span v-if="item.search_name">{{ item.search_name }}</span>
    <span v-else>{{ item.no_result }}</span>
  </div>
</template>

<script>
export default {
  name: "search-list-template",
  props: {
    item: {
      required: true
    }
  }
};
</script>

<style scoped></style>
